namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeMbForm {
        DiscCouponType: Serenity.StringEditor;
        MbType: Serenity.StringEditor;
    }

    export class PsDiscCouponTypeMbForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsDiscCouponTypeMb';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsDiscCouponTypeMbForm.init)  {
                PsDiscCouponTypeMbForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsDiscCouponTypeMbForm, [
                    'DiscCouponType', w0,
                    'MbType', w0
                ]);
            }
        }
    }
}
